<template>
  <svg id="Capa_1" enable-background="new 0 0 512 512" :width="width" :height="height" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path d="m301.891 71.284 32.322-71.284h-156.426l32.322 71.284z" />
      <path
        d="m458.877 334.549-155.349-233.265h-95.055l-155.35 233.265c-23.731 35.632-25.833 79.437-5.623 117.178s57.834 60.273 100.646 60.273h215.708c42.812 0 80.436-22.532 100.646-60.273 20.209-37.741 18.108-81.545-5.623-117.178zm-137.249-80.43h-101.256v37.523h101.257v97.523h-50.629v35.602h-30v-35.602h-50.628v-30h101.257v-37.523h-101.257v-97.523h50.628v-35.602h30v35.602h50.628z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
